<template>
    <SupplyRequestDash></SupplyRequestDash>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SupplyRequestDash = defineAsyncComponent(() =>
    import("../../components/Purchasing/SupplyRequest/SupplyRequestDash.vue")
);

export default {
    name: "SupplyRequestDash_Purchashing",
    components: { SupplyRequestDash, AuthLayout },
};
</script>
